enum AuthErrorCode {
    INVALID = 255,
    VALID = 0,
    DEFAULT = -1
}

export default AuthErrorCode;
